document.addEventListener('DOMContentLoaded', function () {
  let scrollPosition = 0;

  // Create the overlay element and append it to the body
  const overlay = document.createElement('div');
  overlay.className = 'menu-overlay';
  document.body.appendChild(overlay);

  // Helper function to toggle class
  function toggleClass(element, className) {
    element.classList.toggle(className);
  }

  // Helper function to add class
  function addClass(element, className) {
    element.classList.add(className);
  }

  // Helper function to remove class
  function removeClass(element, className) {
    element.classList.remove(className);
  }

  // Helper function to check if element has class
  function hasClass(element, className) {
    return element.classList.contains(className);
  }

  // Get all toggle menu buttons
  const toggleMenuButtons = document.querySelectorAll('.toggleMenu');

  toggleMenuButtons.forEach(function(toggleButton) {
    toggleButton.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default anchor action

      // Get the target menu to toggle based on data attribute
      const targetMenuId = this.dataset.target;
      const targetMenu = document.getElementById(targetMenuId);

      if (!targetMenu) return;

      // Close all other menus
      const openMenus = document.querySelectorAll('.header__inline-menu.is-open');
      openMenus.forEach(function(menu) {
        if (menu !== targetMenu) {
          removeClass(menu, 'is-open');
        }
      });

      // Close the overlay when a different menu is opened
      removeClass(overlay, 'active');

      // Toggle the 'is-open' class on the current menu
      toggleClass(targetMenu, 'is-open');

      // Toggle the 'active' class on the clicked toggleMenu for the dropdown icon
      toggleClass(toggleButton, 'active');

      if (hasClass(targetMenu, 'is-open')) {
        // Save the current scroll position
        scrollPosition = window.scrollY || window.pageYOffset;

        // Lock scroll by setting position fixed and restoring scroll
        addClass(document.body, 'no-scroll');
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        // Show the overlay when menu is open
        addClass(overlay, 'active');
      } else {
        // Remove fixed position and restore scroll position
        removeClass(document.body, 'no-scroll');
        document.body.style.top = '';
        document.body.style.position = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPosition); // Restore scroll position

        // Hide the overlay when the menu is closed
        removeClass(overlay, 'active');
      }

      // Close all first and second-level details when a new menu is toggled
      const firstBlockMenus = document.querySelectorAll('.first__block-menu');
      const secondBlockMenus = document.querySelectorAll('.second__block-menu');

      firstBlockMenus.forEach(function(menu) {
        menu.removeAttribute('open');
      });

      secondBlockMenus.forEach(function(menu) {
        menu.removeAttribute('open');
      });

      // Remove the 'open' attribute for first-level and second-level summaries
      const firstSummaries = document.querySelectorAll('.first__block-menu .first-summary');
      const secondSummaries = document.querySelectorAll('.second__block-menu .second_summary');

      firstSummaries.forEach(function(summary) {
        summary.removeAttribute('open');
      });

      secondSummaries.forEach(function(summary) {
        summary.removeAttribute('open');
      });
    });
  });

  // Close the menu when you click outside of it
  document.addEventListener('click', function(event) {
    const openMenus = document.querySelectorAll('.header__inline-menu.is-open');

    openMenus.forEach(function(menu) {
      const isClickInsideMenu = menu.contains(event.target);
      const isClickOnToggle = event.target.closest('.toggleMenu') !== null;

      if (!isClickInsideMenu && !isClickOnToggle) {
        removeClass(menu, 'is-open');

        // Remove fixed position and restore scroll position
        removeClass(document.body, 'no-scroll');
        document.body.style.top = '';
        document.body.style.position = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPosition);

        // Close all first and second-level details when the menu is closed
        const firstBlockMenus = document.querySelectorAll('.first__block-menu');
        const secondBlockMenus = document.querySelectorAll('.second__block-menu');

        firstBlockMenus.forEach(function(blockMenu) {
          blockMenu.removeAttribute('open');
        });

        secondBlockMenus.forEach(function(blockMenu) {
          blockMenu.removeAttribute('open');
        });

        // Remove the 'open' attribute for first-level and second-level summaries
        const firstSummaries = document.querySelectorAll('.first__block-menu .first-summary');
        const secondSummaries = document.querySelectorAll('.second__block-menu .second_summary');

        firstSummaries.forEach(function(summary) {
          summary.removeAttribute('open');
        });

        secondSummaries.forEach(function(summary) {
          summary.removeAttribute('open');
        });

        // Hide the overlay
        removeClass(overlay, 'active');

        // Remove the 'active' class from all toggleMenu buttons
        const allToggleButtons = document.querySelectorAll('.toggleMenu');
        allToggleButtons.forEach(function(btn) {
          removeClass(btn, 'active');
        });
      }
    });
  });

  // First-level block menu (header menu)
  const firstBlockMenus = document.querySelectorAll('.first__block-menu');

  firstBlockMenus.forEach(function(details) {
    const summary = details.querySelector('.first-summary');

    if (!summary) return;

    summary.addEventListener('click', function() {
      // Close all other first-level blocks except the clicked one
      const allFirstBlocks = document.querySelectorAll('.first__block-menu');
      allFirstBlocks.forEach(function(block) {
        if (block !== details) {
          block.removeAttribute('open');
        }
      });

      // Get all second-level blocks that come after this first-level block
      let currentElement = details.nextElementSibling;
      const secondLevelBlocks = [];

      while (currentElement && hasClass(currentElement, 'second__block-menu')) {
        secondLevelBlocks.push(currentElement);
        currentElement = currentElement.nextElementSibling;
      }

      if (details.hasAttribute('open')) {
        // Optionally open corresponding second-level menu if first-level is open
        secondLevelBlocks.forEach(function(block) {
          block.setAttribute('open', '');
        });
      } else {
        // Close second-level block when first-level is closed
        secondLevelBlocks.forEach(function(block) {
          block.removeAttribute('open');
        });
      }

      // Close all second-level blocks not associated with this first-level block
      const allSecondBlocks = document.querySelectorAll('.second__block-menu');
      allSecondBlocks.forEach(function(block) {
        if (!secondLevelBlocks.includes(block)) {
          block.removeAttribute('open');
        }
      });
    });
  });

  // Second-level block menu (header menu)
  const secondBlockMenus = document.querySelectorAll('.second__block-menu');

  secondBlockMenus.forEach(function(details) {
    const summary = details.querySelector('.second_summary');

    if (!summary) return;

    summary.addEventListener('click', function() {
      // Close all other second-level blocks except the clicked one
      const allSecondBlocks = document.querySelectorAll('.second__block-menu');
      allSecondBlocks.forEach(function(block) {
        if (block !== details) {
          block.removeAttribute('open');
        }
      });
    });
  });
});
